import CpAvatar, { CpAvatarProps } from '@justgiving/carepack-avatar';

import defaultAvatar from '../../../public/default-avatar.svg';

export interface PageOwnerAvatarProps extends Omit<CpAvatarProps, 'src'> {
  src?: CpAvatarProps['src'] | null;
}

export const PageOwnerAvatar = ({ src, ...props }: PageOwnerAvatarProps) => {
  return <CpAvatar src={src ?? defaultAvatar.src} {...props} />;
};
